import {
  // 获取Ranks数据的原接口方法
  fetchStoreRankTops as fetchStoreRankTopsOriginal,
  // mobile 使用的新接口方法
  fetchStoreRankTopsMobile,
} from '@/pages/intelligence/services/storeRank';
import { getSortedTopsKeys, handleStoreRankSource } from '@/pages/intelligence/_config/storeRank/utils';

import type { IGameType } from '@/pages/intelligence/types/common';
import type { IStoreRankTopFetchParams, IFetchStoreRankTopsRes } from '@/pages/intelligence/types/storeRank';

/**
 * 统一处理 个别字段值的特殊转换，提供给接口入参
 * 1、Nintendo平台的 regions 固定传global，因为这个平台没有国家筛选器
 * @param params 原页面参数
 * @returns 处理的，接口入参
 */
// eslint-disable-next-line arrow-body-style
const handleParams = (entityType: IGameType, params: IStoreRankTopFetchParams): IStoreRankTopFetchParams => {
  return {
    ...params,
    entity_type: entityType,
    regions: params?.regions,
  };
};

const handleRes = (
  entityType: IGameType,
  params: IStoreRankTopFetchParams,
  res: IFetchStoreRankTopsRes,
): IFetchStoreRankTopsRes => {
  const tops = res?.data?.map((item) => ({ ...item, name: handleStoreRankSource(item?.name) })) || [];
  const sortedTopsKeys = getSortedTopsKeys(entityType, params?.store, params?.granularity);
  if (!Array.isArray(sortedTopsKeys)) return res;
  const topsTmp = sortedTopsKeys?.map((item) => {
    const top = tops?.find((subItem: any) => subItem?.name === item);
    return {
      name: top?.name || item || '',
      last_date: top?.last_date || '',
      list: top?.list || [],
    };
  });
  return {
    ...res,
    data: topsTmp,
  };
};

/**
 * 对获取Tops数据的原接口方法 增加统一特殊字段值处理的 接口方法，页面调用这个方法
 * @param entityType mobile、pc、console
 * @param params 接口参数
 * @returns 获取Tops数据接口的返回值，页面直接使用
 */
export const fetchStoreRankTops = async (
  entityType: IGameType,
  params: IStoreRankTopFetchParams,
): ReturnType<typeof fetchStoreRankTopsOriginal> => {
  const paramsTmp = handleParams(entityType, params);
  // mobile 使用新接口 getTopChartsStoreRankV2，pc 和 console 使用旧接口
  const res = entityType === 'mobile'
    ? await fetchStoreRankTopsMobile(paramsTmp)
    : await fetchStoreRankTopsOriginal(paramsTmp);
  return handleRes(entityType, params, res);
};
